<form [formGroup]="form" (ngSubmit)="submitForm()">
  <title mat-dialog-title>{{ 'common.addWidget' | t }}</title>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions snButtonGroup>
    <button mat-button color="danger" mat-dialog-close>{{ 'common.cancel' | t }}</button>
    <button mat-button color="success" type="submit" (isLoading)="(isLoading)">{{ 'common.submit' | t }}</button>
  </mat-dialog-actions>
</form>
